import { lazy, Suspense, type ReactElement } from 'react';
import { Box, Spinner } from '@ff-it/ui';

const SurveyList = lazy(() => import('./index').then((module) => ({ default: module.SurveyList })));

export function LazyRadioSurveys({ agencyId }: { agencyId: number }): ReactElement {
  return (
    <Suspense
      fallback={
        <Box p="3">
          <Spinner color="primary" />
        </Box>
      }
    >
      <SurveyList agencyId={agencyId} />
    </Suspense>
  );
}
